/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import FirestoreTimestampToDate from "../helpers/timestampDate";
import { IoCardOutline } from "react-icons/io5";
import { FiBox, FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";

const EtherScan = () => {
  const [id, setId] = useState(localStorage.getItem("roomId") || "");
  const [transactions, setTransactions] = useState([]);
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    const fetchTransactions = async () => {
      const transactionsCollection = db.collection("rooms").doc(id).collection("transactions");
      const snapshot = await transactionsCollection.get();
      const transactionsData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        timestamp: FirestoreTimestampToDate(doc.data().timestamp),
        id: doc.id,
      }));
      setTransactions(transactionsData);
    };

    fetchTransactions();
  }, [id]);

  useEffect(() => {
    const fetchBlocks = async () => {
      const blocksCollection = db.collection("rooms").doc(id).collection("blocks");
      const snapshot = await blocksCollection.get();
      const blocksData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        timestamp: FirestoreTimestampToDate(doc.data().timestamp),
        id: doc.id,
      }));
      setBlocks(blocksData);
    };

    fetchBlocks();
  }, [id]);

  const renderTrimmedAddress = (address) => `${address.toString().substring(0, 10)}...`;

  return (
    <div className="max-w-[1600px]">
      {/* Header */}
      <div className="glass-card p-6 mb-6">
        <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center gap-3">
          <FiBox className="text-primary" />
          AstraScan
          <span className="text-text-muted font-normal text-lg">for {id}</span>
        </h2>
      </div>

      {/* Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Latest Blocks */}
        <div className="glass-card p-6">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
            <FiBox className="text-secondary" /> Latest Blocks
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="p-3 text-left text-text-muted text-sm font-medium"></th>
                  <th className="p-3 text-left text-text-muted text-sm font-medium">Hash</th>
                  <th className="p-3 text-left text-text-muted text-sm font-medium">Nonce</th>
                  <th className="p-3 text-left text-text-muted text-sm font-medium">
                    Previous Hash
                  </th>
                </tr>
              </thead>
              <tbody>
                {blocks.slice(0, 5).map((block, index) => (
                  <tr
                    key={index}
                    className="border-b border-white/5 hover:bg-white/5 transition-colors"
                  >
                    <td className="p-3 text-primary">
                      <IoCardOutline size={20} />
                    </td>
                    <td className="p-3">
                      <code
                        className="text-white bg-white/10 px-2 py-1 rounded text-sm"
                        title={block.hash}
                      >
                        {renderTrimmedAddress(block.hash)}
                      </code>
                    </td>
                    <td className="p-3 text-white">{block.nonce}</td>
                    <td className="p-3">
                      <code
                        className="text-text-muted bg-white/5 px-2 py-1 rounded text-sm"
                        title={block.previousBlockHash}
                      >
                        {block.previousBlockHash
                          ? renderTrimmedAddress(block.previousBlockHash)
                          : "Genesis Block"}
                      </code>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Link
            to="/transaction"
            className="mt-4 inline-flex items-center gap-2 text-primary hover:text-secondary transition-colors"
          >
            View More Transactions <FiArrowRight />
          </Link>
        </div>

        {/* Latest Transactions */}
        <div className="glass-card p-6">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
            <IoCardOutline className="text-primary" /> Latest Transactions
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="p-3 text-left text-text-muted text-sm font-medium"></th>
                  <th className="p-3 text-left text-text-muted text-sm font-medium">ID</th>
                  <th className="p-3 text-left text-text-muted text-sm font-medium">Hash</th>
                  <th className="p-3 text-left text-text-muted text-sm font-medium">From → To</th>
                  <th className="p-3 text-left text-text-muted text-sm font-medium">Amount</th>
                </tr>
              </thead>
              <tbody>
                {transactions.slice(0, 5).map((transaction, index) => (
                  <tr
                    key={index}
                    className="border-b border-white/5 hover:bg-white/5 transition-colors"
                  >
                    <td className="p-3 text-secondary">
                      <IoCardOutline size={20} />
                    </td>
                    <td className="p-3">
                      <code
                        className="text-white bg-white/10 px-2 py-1 rounded text-sm"
                        title={transaction.id}
                      >
                        {renderTrimmedAddress(transaction.id)}
                      </code>
                    </td>
                    <td className="p-3">
                      <code
                        className="text-text-muted bg-white/5 px-2 py-1 rounded text-sm"
                        title={transaction.hash}
                      >
                        {renderTrimmedAddress(transaction.hash)}
                      </code>
                    </td>
                    <td className="p-3">
                      <div className="flex flex-col gap-1 text-sm">
                        <span className="text-green-400" title={transaction.sender}>
                          FROM: {renderTrimmedAddress(transaction.sender)}
                        </span>
                        <span className="text-blue-400" title={transaction.receiver}>
                          TO: {renderTrimmedAddress(transaction.receiver)}
                        </span>
                      </div>
                    </td>
                    <td className="p-3 text-white font-medium">{transaction.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Link
            to="/transaction"
            className="mt-4 inline-flex items-center gap-2 text-primary hover:text-secondary transition-colors"
          >
            View More Transactions <FiArrowRight />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EtherScan;
